<template>
  <div class="all_part">
    <div>
      <titleBlock_computer></titleBlock_computer>
    </div>
    <div class="input_button">
      <div class="all_input">
        <div class="all_input_top">
          <div>
            <el-input
              v-model="number"
              placeholder="请输入任务编号或任务内容"
              style="width: 460px"
            ></el-input>
          </div>
          <div class="submit_button">
            <!-- <div class="search_button">
          <el-button type="primary" @click="TianJiaZhanShi" style="height: 48px; width: 144px"
          >报价筛选
          </el-button
          >
        </div> -->
            <div class="search_button">
              <div class="sousuoButton">
                <el-button
                  type="primary"
                  @click="serchMissioninfo"
                  style="
                    height: 48px;
                    width: 144px;
                    margin-left: 20px;
                    font-size: 16px;
                  "
                  >搜索
                </el-button>
                <div class="icon_sou">
                  <img src="../assets/SouSuo.png" alt="" width="14px" />
                </div>
              </div>
            </div>
            <div class="all_second_button">
              <div class="ChongZhi">
                <div class="second_button" @click="clearInput">
                  <el-button
                    plain
                    type="primary"
                    style="width: 92px; height: 48px; font-size: 16px"
                    >重置
                  </el-button>
                </div>
                <div class="icon_chong">
                  <img src="../assets/ChongZhi.png" alt="" width="14px" />
                </div>
              </div>
              <div class="second_button" @click="clearInput">
                <div class="Fanhu">
                  <div>
                    <el-button
                      plain
                      type="primary"
                      style="width: 92px; height: 48px"
                      @click="back_menu"
                      >返回
                    </el-button>
                  </div>
                  <div class="icon_fan">
                    <img src="../assets/FanHui.png" alt="" width="14px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table">
      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          :row-style="{ height: '70px' }"
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column label="编号" width="120"  prop="id">
          </el-table-column>
          <el-table-column prop="name" label="销售人员" width="120">
          </el-table-column>
          <el-table-column prop="content" label="任务内容" width="200">
          </el-table-column>
          <el-table-column prop="number" label="任务编号" width="180">
          </el-table-column>
          <el-table-column prop="add_time" label="发起日期" width="180">
          </el-table-column>
          <el-table-column
            prop="estimate_time"
            label="预计完成时间"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="days" label="耗时" width="120">
          </el-table-column>
          <el-table-column prop="complete_time" label="完成时间" width="120">
          </el-table-column>
          <el-table-column prop="company" label="授理单位" width="120">
          </el-table-column>
          <el-table-column prop="person" label="负责人" width="120">
          </el-table-column>
          <el-table-column prop="product_name" label="产品大类" width="120">
          </el-table-column>
          <el-table-column
            prop="product_classification"
            label="产品小类"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="support" label="状态" width="120">
          </el-table-column>
          <el-table-column prop="delay" label="延迟时间" width="120">
          </el-table-column>
        </el-table>
      </div>
   
    </div>
    <div class="block">
      <el-pagination
          background
          page-size="20"
          layout="prev, pager, next"
          :total="pageSize"
          hide-on-single-page="true"
          @current-change="reflash"
      >
      </el-pagination>
    </div>
    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>
<script>
import titleBlock_computer from "../views/titleBlock_computer.vue";
import { httpUrl } from "../components/publics";
export default {
  data() {
    return {
      PanDuanShou: false,
      pageSize: "",
      buttonShow: false,
      number: "",
      user_id: 1,
      tableData: [],
    };
  },
  mounted() {
    this.serchMissioninfo();
  },
  components: {
    titleBlock_computer,
  },
  methods: {
    back_menu() {
      this.$router.push("/Main_menuComputer");
    },
    inputShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
      }
    },
    clearInput() {
      this.number = "";
      this.company_Code = "";
      this.document_date = "";
      this.name = "";
      this.full_name = "";
    },
    reflash(val) {
      this.page = val;
      this.serchMissioninfo();
    },
    serchMissioninfo() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
        .get(
          httpUrl +
            `/api/index/task?user_id=${suser_id.id}&number=${this.number}&page=${this.page}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.pageSize = response.data.data.total;
            console.log(this.pageSize);
            this.tableData = response.data.data.data;
            console.log(this.tableData.data);
          }
          this.$message(response.data.message);
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
  },
};
</script>

<style>
.cell {
  text-align: center;
}
.el-table__row {
  background-image: url("../assets/table_logo2.png");
}
</style>
<style scoped>
.all_part {
  min-width: 1920px;
  min-height: 925px;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 0;
}

.table {
  height: 70%;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
}

.all_input_top div {
  margin-left: 10px;
}

.all_input_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.submit_button {

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.all_second_button {
  display: flex;
  flex-direction: row;
}

.second_button {
  margin-left: 20px;
}

.Copyright_information {
  margin-bottom: 15px;
}
.block {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  align-items: center;
  height: 50px;
}
.all_Kong {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 0 20px;
}
.sousuoButton {
  position: relative;
}
.icon_sou {
  top: 16px;
  left: 40px;
  position: absolute;
}
.ChongZhi {
  position: relative;
}
.icon_chong {
  top: 16px;
  left: 12px;
  position: absolute;
}
.ShouQi {
  position: relative;
}
.icon_Shou {
  top: 14px;
  left: 12px;

  position: absolute;
}
.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}
.icon_fan {
  top: 16px;
  left: 12px;
  position: absolute;
}
.Fanhu {
  position: relative;
}
</style>